import { Component, ViewChild } from '@angular/core';
import { BagListItem } from '../models/bag';
import { AdministracionCarteraApiService } from '../services/administracion-cartera-api.service';
import { AlertService } from 'src/app/components/_alert/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { SessionService } from 'src/app/shared/services/session.service';
import { ESystemAccess, ESystemProfileList } from 'src/app/enum/EAccess';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatConfirmDialogComponent } from 'src/app/components/mat-confirm-dialog/mat-confirm-dialog.component';

@Component({
    selector: 'app-admin-cartera-list',
    templateUrl: './admin-cartera-list.component.html',
    styleUrls: ['./admin-cartera-list.component.scss']
})
export class AdminCarteraListComponent {
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    private readonly access: string[] = [
        ESystemAccess.ADMINISTRACION_CARTERA,
        ESystemProfileList.WEB
    ];
    private readonly adminAccess: string = ESystemAccess.ADMINISTRACION_CARTERA_ADMIN;
    
    public isAdmin = false;

    public carteras: BagListItem[] = [];
    
    public isLoading = false;

    public dataSource = new MatTableDataSource<BagListItem>();
    public displayedColumns = ['name', 'id', 'actions'];

    constructor(
        private _apiService: AdministracionCarteraApiService,
        private alertService: AlertService,
        public dialog: MatDialog,
        private _session: SessionService,
        private _router: Router
    ) { }

    ngOnInit() {
        if (!this.checkAccess()) {
            this._router.navigate(['/request-access']);
            return;
        }

        this.getBagList();
    }

    getBagList() {
        this.isLoading = true;
        this._apiService.getBagList().subscribe(
            (response: BagListItem[]) => {
                this.carteras = response;

                setTimeout(() => {
                    this.updateDataSource();
                }, 0);

                this.isLoading = false;
            },
            () => {
                this.alertService.error('Ocurrió un error al intentar obtener las carteras.');
                this.isLoading = false;
            }
        )
    }

    checkAccess() {
        if (this._session.getUserAccess().includes(this.adminAccess)) {
            this.isAdmin = true;
        }

        const hasAdminCarteraPermission = this._session.getUserAccess().includes(this.access[0]);
        const hasWebProfile = this._session.getUserProfileList().includes(this.access[1]);

        return hasAdminCarteraPermission && hasWebProfile;
    }

    removeCartera(id: string) {
        const dialogRef = this.dialog.open(MatConfirmDialogComponent, {
            data: {
                title: 'Confirmación',
                message: `¿Está seguro que desea eliminar la cartera ${id}?`
            }
        });

        dialogRef.afterClosed().subscribe(resp => {
            if (!resp) return;

            this._apiService.deleteBag(id).subscribe(
                () => {
                    this.alertService.success('Cartera eliminada exitosamente.');
                    this.getBagList();
                },
                () => {
                    this.alertService.error('Ocurrió un error al intentar eliminar la cartera.')
                }
            )
        });
    }

    openBag(id: string) {
        this._router.navigate(['/administracion-cartera-detalle', id]);
    }

    createBag() {
        this._router.navigate(['/administracion-cartera-crear']);
    }

    updateDataSource() {
        this.dataSource = new MatTableDataSource<BagListItem>(this.carteras);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

}
